
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppSelectBookYear from "@/components/bookyear/SelectBookYear.vue";
import AppMonthSelect from "@/components/common/MonthSelect.vue";
import { WinbooksService } from "@/services/winbooks-service";
import { BookYearService } from "@/services/book-year-service";
import { downloadBlob } from "@/utils/blob";

export default Vue.extend({
	data() {
		return {
			exportContacts: true,
			exportSales: true,
			bookYear: String(BookYearService.selectedBookYear),
			periodMode: "month" as "month" | "date",
			startMonth: 1,
			endMonth: 12,
			beginDate: new Date(),
			endDate: new Date(),
			exporting: false
		};
	},
	props: {
		dossierName: {
			type: String,
			default: ""
		}
	},
	computed: {
		title():TranslateResult {
			if (this.dossierName) {
				return this.$ct("title-for", {name: this.dossierName});
			}
			return this.$ct("title");
		},
		periodModeItems():{value:string, text:string}[] {
			return [
				{value: "month", text: this.$ct("period-mode.month").toString()},
				{value: "date", text: this.$ct("period-mode.date").toString()}
			];
		},
		canExport():boolean {
			if (this.exporting) return false;
			return this.exportContacts || this.exportSales;
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		async errorDetail(err:any):Promise<string> {
			let data = err?.response?.data;
			if (data instanceof Blob) {
				try {
					data = JSON.parse(await data.text());
				} catch {
					return "";
				}
			}
			if (data && typeof data == "object") {
				if (Array.isArray(data.data) && data.data.length) return String(data.data[0]);
				if (data.message) return String(data.message);
			} else if (typeof data == "string" && data) {
				return data;
			}
			return err?.message || "";
		},
		computePeriod():{begin:Date, end:Date} | null {
			let begin:Date;
			let end:Date;
			if (this.periodMode == "date") {
				begin = new Date(this.beginDate);
				end = new Date(this.endDate);
			} else {
				let yearStart = BookYearService.getBookYearStartDate(Number(this.bookYear));
				begin = new Date(yearStart);
				begin.setMonth(begin.getMonth() + (this.startMonth - 1));
				end = new Date(yearStart);
				end.setMonth(end.getMonth() + this.endMonth);
				end.setDate(end.getDate() - 1);
			}
			if (begin.getTime() > end.getTime()) {
				return null;
			}
			return {begin, end};
		},
		async create() {
			let period:{begin:Date, end:Date} | null = null;
			if (this.exportSales) {
				period = this.computePeriod();
				if (!period) {
					this.$wf.notify(this.$ct("invalid-period").toString(), "error", 4000, "exclamation-triangle");
					return;
				}
			}
			this.exporting = true;
			try {
				let blob = await WinbooksService.export({
					bookYear: Number(this.bookYear),
					beginDate: period?.begin,
					endDate: period?.end,
					exportContacts: this.exportContacts,
					exportSales: this.exportSales
				});
				let date = new Date().toISOString().slice(0, 10);
				downloadBlob(blob, `WinBooks-${date}.zip`);
				this.$emit("close");
			} catch (err) {
				let detail = await this.errorDetail(err);
				let msg = this.$ct("export-error").toString();
				if (detail) msg += `: ${detail}`;
				this.$wf.notify(msg, "error", 10000, "exclamation-triangle");
			} finally {
				this.exporting = false;
			}
		}
	},
	components: {
		AppSelectBookYear,
		AppMonthSelect
	},
	i18nEx: {
		componentPrefix: "components.accountant-ExportToWinbooksModal"
	}
});
